import React from 'react';

import Hero from 'components/Hero';
import WhatWeDo from 'components/WhatWeDo';
import AIAssistant from 'components/AIAssistant';
import Toolbox from 'components/Toolbox';
import WhoAreWe from 'components/WhoAreWe';

const Home = () => (
  <div>
    <Hero />
    <AIAssistant />
    <WhatWeDo />
    <Toolbox />
    <WhoAreWe />
  </div>
);

export default Home;
